import { render, staticRenderFns } from "./CreateBookingView.vue?vue&type=template&id=7460c31c&scoped=true"
import script from "./CreateBookingView.vue?vue&type=script&lang=js"
export * from "./CreateBookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460c31c",
  null
  
)

export default component.exports